export const m = {
    // 顶部参数
    welcome: '欢迎光临华陇国际建设股份有限公司官网',
    searchTxt: '请输入关键词查找',
    email: '企业邮箱',
    chinese: '中文',
    // 底部参数
    footerLeft: `<a href="/">网站首页</a><span>|</span>
    <a href="/joinUs">加入我们</a><span>|</span>
    <a href="/contact">联络我们</a><span>|</span>
    <a href="/">法律声明</a>            
    <p> 
      <a href="/">华陇国际建设股份有限公司</a>丨 版权所有 
      <a href="https://beian.miit.gov.cn" target="_blank"> 京ICP备20017936号</a>
    </p>`,

    // 联络我们页面
    contact: '联络我们',
    contactWay: '联系方式',
    contactExplain: '如果您有任何问题都可以通过以下方式联系到我们',
    contactInfo: `<h3>华陇国际建设股份有限公司</h3>
    <p>电话：010-56540571</p>
    <p>传真：010-56540571</p>
    <p>邮箱：sinoron@sinoron.com.cn</p>
    <p>地址：北京市丰台区汉威国际广场二区2号楼4M层</p>`,

    // 加入我们页面
    joinUs: '加入我们',

    //企业文化页面
    culture: '企业文化',
    cultureIdea: '企业理念',
    cultureIdeaInfo: '匠心营造，精益求精',
    mission: '企业使命',
    missionInfo: '诚信经营 业务精良 满意服务 共筑未来',
    vision: '企业愿景',
    visionInfo: '诚信、严谨、自强、发展',
    value: '企业核心价值',
    valueInfo: '竭诚、责任、求精、共赢',
    target: '打造国际一流工程服务平台',

    //业务领域
    business: '业务领域',

    //新闻列表
    topNews: '推荐咨询',

    //新闻详情页
    topTitle: '上一篇',
    bottomTitle: '下一篇',
    none: '没有了',

    // 搜索页面
    search: '搜索结果',
}